import { Link } from "react-router-dom";
import Button from "@/components/base/Button";
import Reveal from "@/components/base/Reveal";
import { useUi } from "@/context/UiContext";

export default function FinalCta() {
  const { openQuiz, openAi } = useUi();

  return (
    <section className="bg-primary-dark">
      <div className="mx-auto max-w-container px-4 md:px-6 py-14 md:py-20 lg:py-24">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-gold">
              Take the First Step
            </p>
            <h2 className="mt-5 text-2xl md:text-[2.125rem] font-bold leading-[1.35] text-white">
              改變，不需要等到一切都準備好。
            </h2>
            <p className="mt-6 text-base leading-[1.8] text-gold-soft/90">
              也許你現在還沒有完整答案。先從看見目前真正卡住自己的地方開始。
              一個清楚的問題，加上一個做得到的小行動，就可能是下一段改變的起點。
            </p>

            <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={openQuiz} size="lg" icon="ri-arrow-right-line">
                30 秒找出我的行動卡點
              </Button>
              <Button onClick={openAi} size="lg" variant="outline-light">
                和 AI 幸福人才顧問聊聊
              </Button>
            </div>

            <Link
              to="/contact#corporate-form"
              className="mt-7 inline-flex items-center gap-2 text-sm font-semibold text-gold cursor-pointer transition-colors duration-200 hover:text-gold-soft"
            >
              提出企業培訓需求
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}